import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path1/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "compatible-plugin-list"
    }}>{`Compatible Plugin List`}</h1>
    <p>{`Cartsy built on proper WordPress and WooCommerce coding standards, and for that, all the org plugins should be working fine by default. However, we test some popular plugins and provide custom design and support for that plugin. You'll get the full list here:`}</p>
    <h2 {...{
      "id": "required"
    }}>{`Required`}</h2>
    <ul>
      <li parentName="ul">{`Cartsy theme helper `}{`[by RedQ]`}</li>
      <li parentName="ul">{`RedQ reuse form `}{`[by RedQ]`}</li>
      <li parentName="ul">{`Google map loader `}{`[by RedQ]`}</li>
      <li parentName="ul">{`WooCommerce (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/woocommerce/"
        }}>{`https://wordpress.org/plugins/woocommerce/`}</a>{`)`}</li>
      <li parentName="ul">{`Kirki Customizer Framework (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/kirki/"
        }}>{`https://wordpress.org/plugins/kirki/`}</a>{`)`}</li>
      <li parentName="ul">{`Contact Form 7 (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/contact-form-7/"
        }}>{`https://wordpress.org/plugins/contact-form-7/`}</a>{`)`}</li>
      <li parentName="ul">{`WP SVG images (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/wp-svg-images/"
        }}>{`https://wordpress.org/plugins/wp-svg-images/`}</a>{`)`}</li>
      <li parentName="ul">{`One click demo importer (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/one-click-demo-import/"
        }}>{`https://wordpress.org/plugins/one-click-demo-import/`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "recommended"
    }}>{`Recommended`}</h2>
    <ul>
      <li parentName="ul">{`Cartsy Algolia `}{`[by RedQ]`}</li>
      <li parentName="ul">{`Firebase mobile authentication `}{`[by RedQ]`}</li>
      <li parentName="ul">{`GridSter `}{`[by RedQ]`}</li>
      <li parentName="ul">{`Dokan `}{`[lite & pro both]`}</li>
      <li parentName="ul">{`Photo review and rating plugin `}{`[by RedQ]`}</li>
      <li parentName="ul">{`WooCommerce Quick view `}{`[by RedQ]`}</li>
      <li parentName="ul">{`Snazzy maps (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/snazzy-maps/"
        }}>{`https://wordpress.org/plugins/snazzy-maps/`}</a>{`)`}</li>
      <li parentName="ul">{`GDPR Cookie Notice (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/cookie-notice/"
        }}>{`https://wordpress.org/plugins/cookie-notice/`}</a>{`)`}</li>
      <li parentName="ul">{`Facebook Messenger Chat (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/facebook-messenger-customer-chat/"
        }}>{`https://wordpress.org/plugins/facebook-messenger-customer-chat/`}</a>{`)`}</li>
      <li parentName="ul">{`Nextend Social Login (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/nextend-facebook-connect/"
        }}>{`https://wordpress.org/plugins/nextend-facebook-connect/`}</a>{`)`}</li>
      <li parentName="ul">{`Product Social Sharing (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/wpupper-share-buttons/"
        }}>{`https://wordpress.org/plugins/wpupper-share-buttons/`}</a>{`)`}</li>
      <li parentName="ul">{`YITH Wishlist (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/yith-woocommerce-wishlist/"
        }}>{`https://wordpress.org/plugins/yith-woocommerce-wishlist/`}</a>{`)`}</li>
      <li parentName="ul">{`Whatsapp Chat Support (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/wp-whatsapp-chat/"
        }}>{`https://wordpress.org/plugins/wp-whatsapp-chat/`}</a>{`)`}</li>
      <li parentName="ul">{`WPML Translation (`}<a parentName="li" {...{
          "href": "https://wpml.org/"
        }}>{`https://wpml.org/`}</a>{`)`}</li>
      <li parentName="ul">{`PWA Support (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/super-progressive-web-apps/"
        }}>{`https://wordpress.org/plugins/super-progressive-web-apps/`}</a>{`)`}</li>
      <li parentName="ul">{`WOOCS - WooCommerce Currency Switcher (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/woocommerce-currency-switcher/"
        }}>{`https://wordpress.org/plugins/woocommerce-currency-switcher/`}</a>{`)`}</li>
      <li parentName="ul">{`Variation Swatches for WooCommerce (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/woo-variation-swatches/"
        }}>{`https://wordpress.org/plugins/woo-variation-swatches/`}</a>{`)`}</li>
      <li parentName="ul">{`Intuitive Custom Post Order (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/intuitive-custom-post-order/"
        }}>{`https://wordpress.org/plugins/intuitive-custom-post-order/`}</a>{`)`}</li>
      <li parentName="ul">{`Bomb – SMS Notifier (`}<a parentName="li" {...{
          "href": "https://wordpress.org/plugins/bomb-sms-notifier/"
        }}>{`https://wordpress.org/plugins/bomb-sms-notifier/`}</a>{`)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      